import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './components';
import registerServiceWorker from './util/registerServiceWorker';
import { storeConsoleLog, console_log } from './util/object';
import { reportSystemException } from './util/util';
import { ErrorBoundary } from './components/Util';

storeConsoleLog();    // hijack all console.log() output to CONSLOG
registerServiceWorker();    // do this early, moved down from index.html

// generic way of cacthing (works)
window.onerror = function(message, source, lineno, colno, error) {
    console_log("exception.666:  EXECUTION EXCEPTION:  ", message, " src=",source, " lineno=",lineno, " error=",error);
    console_log("exception.777:  EXECUTION EXCEPTION:   stack=",error.stack);
    reportSystemException();        // write session out
}


ReactDOM.render(
     <BrowserRouter>
        <ErrorBoundary>
            <App/>
        </ErrorBoundary>
     </BrowserRouter>,
     document.getElementById('root')
);
